var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 18.5H16.1094V9.86719C16.1094 6.28457 13.4611 3.32402 10.0156 2.83145V1.84375C10.0156 1.28262 9.56113 0.828125 9 0.828125C8.43887 0.828125 7.98438 1.28262 7.98438 1.84375V2.83145C4.53887 3.32402 1.89062 6.28457 1.89062 9.86719V18.5H1.28125C0.831836 18.5 0.46875 18.8631 0.46875 19.3125V20.125C0.46875 20.2367 0.560156 20.3281 0.671875 20.3281H6.15625C6.15625 21.8973 7.43086 23.1719 9 23.1719C10.5691 23.1719 11.8438 21.8973 11.8438 20.3281H17.3281C17.4398 20.3281 17.5312 20.2367 17.5312 20.125V19.3125C17.5312 18.8631 17.1682 18.5 16.7188 18.5ZM9 21.5469C8.32715 21.5469 7.78125 21.001 7.78125 20.3281H10.2188C10.2188 21.001 9.67285 21.5469 9 21.5469ZM3.71875 18.5V9.86719C3.71875 8.45547 4.26719 7.13008 5.26504 6.13223C6.26289 5.13438 7.58828 4.58594 9 4.58594C10.4117 4.58594 11.7371 5.13438 12.735 6.13223C13.7328 7.13008 14.2812 8.45547 14.2812 9.86719V18.5H3.71875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.c3a1425a1853f59a0048e8a974052fac.svg";
export { ForwardRef as ReactComponent };